import React from 'react';
import Button from '@bufferapp/ui/Button';

import { useAppSelector } from '~/store';
import { selectGenerateContentLimits } from '~/ai/state/aiLimits/slice';
import { useAccount } from '~/accountContext';
import { getURL } from '~/server/formatters';

import * as Styled from './styles';

/**
 *
 */
const UpgradeOptions = () => {
  const [isFree, setIsFree] = React.useState<boolean>(false);
  const { account } = useAccount();

  const { generateContentTokensLeft } = useAppSelector((state) =>
    selectGenerateContentLimits(state)
  );

  React.useEffect(() => {
    if (!account?.currentOrganization?.billing) return;

    const { billing } = account.currentOrganization;
    const { subscription } = billing || {};
    const { plan } = subscription || {};

    setIsFree(plan?.id === 'free');
  }, [account]);

  const onUpgradePlan = () => {
    const { actions, MODALS } = window?.appshell || {};
    actions.openModal(MODALS.planSelector, {
      cta: 'ideas-contentGeneration-button-1',
      ctaButton: 'ideas-contentGeneration-button-1',
      upgradePathName: 'ideasContentGeneration-upgrade',
    });
  };

  const onAddChannel = () => {
    const accountChannelsURL = getURL.getAccountChannelsURL();
    window.location.replace(accountChannelsURL);
  };

  return account ? (
    <>
      <Styled.Title>
        {generateContentTokensLeft > 0
          ? 'Get more AI Credits'
          : 'You’ve used up all your AI Credits'}
      </Styled.Title>
      <Styled.Text>
        {isFree
          ? 'You can get additional AI credits by upgrading to a paid plan.'
          : 'Upgrade your plan or pay for an additional channel to get more AI Credits.'}
      </Styled.Text>
      <Styled.Buttons>
        <Button type="primary" onClick={onUpgradePlan} label="Upgrade Plan" />
        {!isFree && (
          <Button
            type="secondary"
            onClick={onAddChannel}
            label="Add Channels"
          />
        )}
      </Styled.Buttons>
    </>
  ) : null;
};

export { UpgradeOptions };
